module.exports = __webpack_public_path__ + "img/devs.fca32a94.jpg";